/**
 * VendorProductTypeService
 * Service for managing vendor product types
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor product type CRUD operations
 */
export class VendorProductTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorProductTypeService.DEFAULT_SERVICE_PATH,
            basePath: VendorProductTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
VendorProductTypeService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorProductTypeService.BASE_PATH = 'api/vendor-product-types';
//# sourceMappingURL=VendorProductTypeService.js.map